import api from "./api";

// Types for test assignment (customize as needed)
export interface TestAssignment {
  id: number;
  test_name: string;
  test_id?: number;
  completed_at?: string;
  score?: number;
  user_name?: string;
  role?: string;
  subscription_status?: string;
}

// Fetch all test assignments for a user
export const listTestAssignments = (userId: string | number) =>
  api.get<TestAssignment[]>(`user/${userId}/test-assignments/`).then((r) => r.data);

// (Optional) Assign a test to a user
export const assignTestToUser = (userId: string | number, testId: string | number) =>
  api.post(`user/${userId}/assign-test/`, { test_id: testId });

// Fetch details for a specific test assignment
export const getTestAssignmentDetails = (assignmentId: string | number) =>
  api.get(`assignment/${assignmentId}/`).then((r) => r.data);